module.exports = __webpack_public_path__ + "img/title4.01102a78.png";